/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {usePageData} from '../../core'
import {PAGE_PERMISSION} from '../../../../app/modules/roles/constant/role-default'

export function AsideMenuMain() {
  const intl = useIntl()
  const [isAdministrator, setIsAdministrator] = useState(false)
  const {currentUser} = usePageData()

  useEffect(() => {
    setIsAdministrator(currentUser.userRoles.includes('Administrator'))
  }, [currentUser.userRoles])

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        title='Dashboard'
        fontIcon='bi-chat-left'
        icon='/media/icons/tims/menu-dashboard.svg'
        pagePermission={PAGE_PERMISSION.Dashboard}
      />

      <AsideMenuItem
        to='/user'
        title={intl.formatMessage({id: 'MENU.USERS'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/tims/menu-users.svg'
        pagePermission={PAGE_PERMISSION.Users}
      />

      <AsideMenuItem
        to='/audit'
        title={intl.formatMessage({id: 'MENU.AUDIT'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/tims/menu-audit.svg'
        pagePermission={PAGE_PERMISSION.Audit}
      />
    </>
  )
}
